// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"351":"6df77b48","565":"d5ae5d00","836":"94fb96b1","906":"0be5e811","998":"36226399"}[chunkId] + ".chunk.js");